import * as React from "react";
import * as ReactDOM from "react-dom";

import Application from './components/Application';

ReactDOM.render(
    <Application />,
    document.getElementById('content')
);


// WEBPACK FOOTER //
// ./Scripts/index.tsx